import Select from 'components/common/forms/Select'
import ErrorPanel from 'components/common/panel/ErrorPanel'
import _ from 'lodash'
import { MDBRow, MDBCol, MDBInput, MDBFileInput } from 'mdbreact'
import React from 'react'

const ContractActivityForm = ({
  params,
  setParams,
  selected,
  setSelected,
  documentTypeOptions,
  errors,
}) => {
  //// HOOKS.

  //// GLOBAL STATE.

  //// LOCAL STATE.

  //// LIFECYCLE HELPERS.

  //// MEMOS.

  //// EFFECTS.

  //// RENDER VARS & HELPERS.

  //// RENDER.
  return (
    <MDBRow>
      {selected ? (
        ''
      ) : (
        <>
          <MDBCol md="12">
            <Select
              id="select__document-types"
              options={documentTypeOptions}
              getTextContent={(v) => {
                if (v !== 'Choose A Document Type') {
                  const currentDocumentType = documentTypeOptions.filter(
                    (documentType) => documentType.value === v
                  )
                  setParams({
                    ...params,
                    contract_document_type_id: `${currentDocumentType[0].id}`,
                  })
                  if (
                    selected &&
                    selected.contract_document_type.id !==
                      currentDocumentType[0].id
                  ) {
                    setSelected({
                      ...selected,
                      contract_document_type: {
                        id: currentDocumentType[0].id,
                        name: currentDocumentType[0].value,
                      },
                    })
                  }
                } else {
                  setParams({ ...params, contract_document_type_id: '' })
                }
              }}
              label="Document Type"
              defaultOption="Choose A Document Type"
              additionalClasses="mb-0"
              search
              required
              errors={errors}
            />
          </MDBCol>

          <MDBCol md="12">
            <MDBFileInput
              textFieldTitle="Upload a document"
              btnColor="primary"
              getValue={(v) => {
                setParams({ ...params, import_file: v[0] })
                if (selected && !_.isEqual(selected.import_file, v[0])) {
                  setSelected({ ...selected, import_file: v[0] })
                }
              }}
            />
          </MDBCol>
        </>
      )}

      <MDBCol md="12">
        <MDBInput
          value={params.comment}
          getValue={(v) => {
            setParams({ ...params, comment: v })
            if (selected && selected.comment !== v) {
              setSelected({ ...selected, comment: v })
            }
          }}
          id="comment-input"
          label="Comment"
          type="textarea"
          rows="3"
          outline
          className="md-textarea mb-0 input-select"
        />
      </MDBCol>

      <ErrorPanel results={errors} />
    </MDBRow>
  )
}

export default ContractActivityForm
